import { useSuspenseQuery } from "@tanstack/react-query";

import { useEnableGcpFakeSystemEngine } from "featureFlags/hooks/useEnableGcpFakeSystemEngine";
import { ReactQueryKeysAccount } from "services/queryKeys";

import { View, getViews } from "./getViews";

export const useViewNames = ({ database }: { database: string }): View[] => {
  const endpoint = useEnableGcpFakeSystemEngine();
  const { data } = useSuspenseQuery<View[], Error>({
    queryKey: [ReactQueryKeysAccount.viewNames, database],
    queryFn: async () => {
      const views = await getViews(database, { endpoint });
      return views;
    },
  });
  return data || [];
};
